import React from 'react';
import { HomeHeroProps } from './home-hero.props';
import { useHomeHeroStyles } from '../../../styles/organisms/home-hero.styles';
import { GetInTouchMolecule } from '../../molecules';
import { homeContent } from '../../../enums/homepage';
import LazyLoad from 'react-lazyload';

export const HomeHeroOrganism = (props: HomeHeroProps) => {
  const classes = useHomeHeroStyles();
  return (
    <section
      className={`w-full bg-waldo-blue block ${classes.bgBlueWhiteHorizontal}`}
    >
      <div
        className={`w-full pt-0 lg:w-93/100 mx-auto  bg-waldo-hero-two  relative ${classes.bgHero}`}
      >
        <div className="w-full h-auto relative flex flex-col lg:flex-row justify-center items-center">
          <article
            className="w-full lg:w-2/5  mx-auto
          ml-0 lg:ml-1/20  mt-1 lg:mt-0
          relative flex flex-col justify-end  box-border"
          >
            <div
              className="w-11/12 lg:w-full max-w-full lg:max-w-lg mx-auto
            mt-0 relative z-20
            pt-5 lg:pt-0 justify-self-center lg:justify-self-end"
            >
              <h2 className="text-center lg:text-left text-4.5xl lg:text-4xl leading-12 lg:leading-10 mb-5 lg:mb-0">
                {props.heroContent.title}
              </h2>
              <p className="mt-5 w-96 hidden lg:block">
                {props.heroContent.desc}
              </p>
              <div className="w-full hidden lg:block flex flex-row justify-start items-start">
                <div className="w-52">
                  <GetInTouchMolecule label={homeContent.CTA} addClass="pt-6" />
                </div>
              </div>
            </div>
          </article>
          <div className="w-full lg:w-3/5 my-0 h-full flex self-stretch relative">
            <div className="w-full box-border self-end -mb-2">
              <LazyLoad offset={500} height={500}>
                <img
                  src="/images/home/hero_woman_desktop.png"
                  className="hidden lg:block"
                />
              </LazyLoad>
              <LazyLoad offset={400} height={400}>
                <img
                  src="/images/home/hero_woman_mobile.png"
                  className="block lg:hidden"
                />
              </LazyLoad>
            </div>
            <div className="w-4/5 left-1/10   block lg:hidden absolute bottom-5">
              <GetInTouchMolecule label={homeContent.CTA} addClass="pt-5" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
